// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"6fbbba25","240":"e9dffdbb","648":"9f4cc502","893":"699a2c3d","992":"97b8e40d"}[chunkId] + ".chunk.css";
};